import * as React from 'react'

import { cn } from '@/utils'

export type TextareaProps = React.ComponentProps<'textarea'>

/**
 * Multi-line counterpart to `ui/input.tsx` — same border/focus/invalid treatment, sized by rows
 * rather than a height variant. Kept variant-less on purpose: there is exactly one consumer today
 * (the Text on a Path action bar), and a `textarea-variants.ts` would pull in a co-located test for
 * no behavior.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        data-slot="textarea"
        className={cn(
          'placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input field-sizing-content w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-sm shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Textarea.displayName = 'Textarea'

export { Textarea }
